import { ComponentSingleStyleConfig } from "@chakra-ui/react";
import { focusRingInvalid, focusRing } from "../focusStyles";

export const numberInputTheme: ComponentSingleStyleConfig = {
  variants: {
    outline: {
      field: {
        borderRadius: "md",
        _hover: {
          borderColor: "gray.400",
        },
        _focus: {
          borderColor: "gray.700",
          ...focusRing,
        },
      },

      // error state on a form
      _invalid: {
        borderColor: "error.500",
        _hover: {
          borderColor: "error.500",
        },
        _focus: {
          borderColor: "error.500",
          ...focusRingInvalid,
        },
      },
    },
  },
};
